import axios from 'axios'

// add click event listener to dynamic elements with class js-add-to-cart
document.body.addEventListener('click', function (e) {
    if ( e.target.classList.contains('js-add-to-cart') && !e.target.classList.contains('product-detail') ) {
        e.preventDefault()
        LBAddToCart(e.target.dataset.id)
    }
})

const LBAddToCart = (id) => {

    axios.get(`/kosik/pridat-do-kosika-lb/${id}`)
        .then(response => {
            if ( response.data.status === 'success' ) {
                updateCart(response.data)
                displayProductPopup(response.data.cartItem)
            }

            if ( response.data.status === 'error' ) {
                flash(response.data.message, response.data.class)
            }
        }).catch(error => {
        console.error(error)
    })
}
